import React, { useState, useRef, useEffect } from 'react';
import Icon from '../../../Assets/Icon/CustomIcons';

export default function ComboBox({
  value,
  onChange,
  items,
  placeholder = '선택하세요',
}) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  const selectedItem = items.find(
    (item) => item.value === value || item.code === value
  );

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative w-full font-sans" ref={containerRef}>
      <div
        onClick={() => setIsOpen(!isOpen)}
        className={`
          flex items-center justify-between px-4 w-full h-10
          bg-white rounded-2xl cursor-pointer transition-all duration-200 ring-primary/10 ring-2
          ${isOpen ? 'shadow-md' : 'shadow-soft '}
          hover:shadow-md
        `}
      >
        <span
          className={`text-[16px] font-semibold ${selectedItem ? 'text-textMain' : 'text-textMuted'}`}
        >
          {selectedItem ? selectedItem.name || selectedItem.label : placeholder}
        </span>

        <div
          className={`transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
        >
          <Icon.DownCircle style={{ fontSize: '24px', color: '#77b054' }} />
        </div>
      </div>

      {isOpen && (
        <ul className="absolute z-50 w-full mt-2 py-2 bg-white border border-transparent rounded-2xl shadow-lg max-h-62.5 overflow-y-auto custom-scrollbar">
          {items.length > 0 ? (
            items.map((item, idx) => (
              <li
                key={idx}
                onClick={() => {
                  onChange({ target: { value: item.value || item.code } });
                  setIsOpen(false);
                }}
                className={`
                  px-6 py-3 text-[15px] font-medium cursor-pointer transition-colors
                  hover:bg-primary/5 hover:text-primary
                  ${item.value === value || item.code === value ? 'bg-primary/10 text-primary font-bold' : 'text-textMain'}
                `}
              >
                {item.name || item.label}
              </li>
            ))
          ) : (
            <li className="px-6 py-3 text-sm text-textMuted text-center">
              데이터가 없습니다.
            </li>
          )}
        </ul>
      )}
    </div>
  );
}
